import React from 'react'
import MuiTable from '../../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_RECONOCIMIENTO_STOCK } from '../../../../../config/tables'

export default function ReconocimientoStockView () {
  return <MuiTable id={TABLA_RECONOCIMIENTO_STOCK} />
}
